import { Checkbox, FormControlLabel, makeStyles, Paper, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { DefaultInputProps, TipoImpresa } from '../../types/types';
import { API_elaboraIForfetari } from '../../utils/functions';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             //minWidth: 320,
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         },
//     }),
// );

export default function RedditoContributiImposta(props: DefaultInputProps) {
    const [global] = useGlobal<IGlobalState>();
    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeContributiImposta";
    const { state } = props;

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraIForfetari(props, global, name, checked, action, true);
    }

    const handleBlur = (e: any) => {
        // API_elaboraIForfetari(props, global);
    }

    let show35: boolean = (props.state.tipologia === TipoImpresa.Impresa) && state.famigliare;
    let showImpresa: boolean = (props.state.tipologia === TipoImpresa.Impresa);
    //let display35 = show35 ? "" : "none";
    let displayImpresa = showImpresa ? "" : "none";
    let showCollab1: boolean = state.quotaCollab1 > 0;
    let showCollab2: boolean = state.quotaCollab2 > 0;
    let displayFamigliare = state.famigliare ? "" : "none";
    let showCassaProf: boolean = state.gestionePrevidenziale.cassaProfessionale;
    let showGestSeparata: boolean = state.gestionePrevidenziale.aliquotaSep > 0;

    return (
        <Paper className={gClasses.mainPaper}>
            <div>
                <SectionTitle text="Contributi - Imposta sostitutiva"></SectionTitle>
                <NumberField
                    name="ricavi"
                    label={state.tipologia.valueOf() === TipoImpresa.Impresa.valueOf() ? "Ricavi" : "Compensi"}
                    value={state.redditoContributiImposta.ricavi}
                    onChange={handleChange} onBlur={handleBlur}
                    className={gClasses.textField}
                />
                <div>
                    <NumberField
                        name="redditoLordo"
                        label="Reddito Lordo"
                        value={state.redditoContributiImposta.redditoLordo}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                </div>
                <div>

                    <NumberField
                        hide={!showImpresa}
                        name="redditoIvs"
                        label="Reddito per IVS"
                        value={state.redditoContributiImposta.redditoPerIvs}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        hide={!show35 || !showCollab1}
                        name="redditoIvsCollab1"
                        label="Reddito IVS collab. 1"
                        value={state.redditoContributiImposta.redditoIvsCollab1}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        hide={!show35 || !showCollab2}
                        name="redditoIvsCollab2"
                        label="Reddito IVS collab. 2"
                        value={state.redditoContributiImposta.redditoIvsCollab2}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                </div>
                <div>
                    <NumberField
                        hide={!showImpresa}
                        name="contribIvs"
                        label="Contributi IVS"
                        value={state.redditoContributiImposta.contributiIvs}
                        onChange={handleChange}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        hide={!show35 || !showCollab1}
                        name="contribIvsCollab1"
                        label="Contributi IVS collab. 1"
                        value={state.redditoContributiImposta.contribIvsCollab1}
                        onChange={handleChange}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                        forcedError={state.redditoContributiImposta.warningContributi35}
                        forcedErrorMessage={state.redditoContributiImposta.warningContributi35 ? "N. mesi: " + state.redditoContributiImposta.mesiWarningContributi35Collab1.toString() : ""}
                    />
                    <NumberField
                        hide={!show35 || !showCollab2}
                        name="contribIvsCollab2"
                        label="Contributi IVS collab. 2"
                        value={state.redditoContributiImposta.contribIvsCollab2}
                        onChange={handleChange}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                        forcedError={state.redditoContributiImposta.warningContributi35}
                        forcedErrorMessage={state.redditoContributiImposta.warningContributi35 ?  "N. mesi: " + state.redditoContributiImposta.mesiWarningContributi35Collab2.toString() : ""}
                    />
                    {/* {<NumberField
                        hide={!state.redditoContributiImposta.warningContributi35 || !showCollab2}
                        name="warningMesiContribIvsCollab2"
                        value={state.redditoContributiImposta.mesiWarningContributi35Collab2}
                        onChange={handleChange}
                        readOnly={true}
                        className={classes.textField}
                    />} */}
                </div>
                <div>
                    <FormControlLabel
                        style={{ display: displayImpresa }}
                        className={gClasses.bottomControlLabel}
                        control={
                            <Checkbox
                                checked={state.redditoContributiImposta.riduzione35}
                                name='riduzione35'
                                id='riduzione35'
                                onChange={handleChangeChecked}
                                inputProps={{
                                    'aria-label': 'primary checkbox',
                                }
                                } />} label="Riduzione 35%" />
                </div>
                <div>
                    <NumberField
                        hide={!showImpresa}
                        name="contributiIvsNetti"
                        label="Contributi IVS Netti"
                        value={state.redditoContributiImposta.contributiIvsNetti}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                        forcedError={state.redditoContributiImposta.warningContributi35}
                        forcedErrorMessage={state.redditoContributiImposta.warningContributi35 ?  "N. mesi: " + state.redditoContributiImposta.mesiWarningContributi35Netti.toString() : ""}
                    />
                    {/* <NumberField
                        hide={!state.redditoContributiImposta.warningContributi35}
                        name="warningMesiContributiIvsNetti"
                        value={state.redditoContributiImposta.mesiWarningContributi35Netti}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={classes.textField}
                        symbol=" "
                    /> */}
                    {state.redditoContributiImposta.warningContributi35 === true ? <Typography style={{ marginTop: "8px" }} variant="body1" color="error">I contributi IVS ridotti del 35% per titolare e/o collaboratori, sono inferiori a quelli dovuti sul minimale di reddito. Ai fini del diritto alla pensione, sarà accreditato, come indicato, un numero di mesi inferiore a 12.</Typography> : <p></p>}
                    <FormControlLabel
                        style={{ display: displayFamigliare }}
                        className={gClasses.bottomControlLabel}
                        control={
                            <Checkbox
                                checked={state.redditoContributiImposta.rivalsa}
                                name='rivalsa'
                                id='rivalsa'
                                onChange={handleChangeChecked}
                                inputProps={{ 'aria-label': 'primary checkbox', }}
                            />}
                        label="Rivalsa"
                    />
                    <NumberField
                        hide={!showImpresa}
                        name="contributiIvsDeducibili"
                        label="Contributi IVS Deducibili"
                        value={state.redditoContributiImposta.contributiIvsDeducibili}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        hide={!showGestSeparata}
                        name="contributiGestSep"
                        label="Contributi gest. separata"
                        value={state.redditoContributiImposta.contributiGestSep}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        hide={!showCassaProf}
                        name="contributiCassaProf"
                        label="Contributi cassa professionale "
                        value={state.redditoContributiImposta.contributiCassaProf}
                        onChange={handleChange} onBlur={handleBlur}
                        className={gClasses.textField}
                    />
                </div>
                <div>
                    <NumberField
                        name="redditoNetto"
                        label="Imponibile Imposta sostitutiva"
                        value={state.redditoContributiImposta.redditoNetto}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />

                    <NumberField
                        name="impostaSostitutiva"
                        label="Imposta sostitutiva"
                        value={state.redditoContributiImposta.impostaSostitutiva}
                        onChange={handleChange} onBlur={handleBlur}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                </div>
            </div>
        </Paper>
    );
}